import * as React from "react";
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { Property } from "../../../Entity/Entities/Property/Property";
import { Unit } from "../../../Entity/Entities/Unit/Unit";
import { Contract } from "../../../Entity/Entities/Contract/Contract";
import { Company } from "../../../Entity/Entities/Company/Company";
import { Person } from "../../../Entity/Entities/Person/Person";
// import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";
import Searchbar from "../../Partials/Searchbar/Searchbar";
import { Attachment } from "../../Partials/Attachment/Attachment";
import * as uuidV4 from "uuid/v4";

import Card from '@material-ui/core/Card';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Checkbox from '@material-ui/core/Checkbox';

import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import {
  TimePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

class NoteCreate extends Component {
  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.GLOBAL_EVENT_CREATE_CLEAR;
  protected middlewares: MiddlewareInterface[] = [
    PreventPageLeave
  ];

  public state = {
    note: "",
    notificationDate: new Date(),
    notificationTime: new Date(),
    showPickers: false,
    selectedEntityForNoteManuallyChanged: false,
    selectedEntityForNote: null,
    hasModifiedData: false,
    isSaving: false,
    openLeavePrompt: false,
    amazonFolderName:  uuidV4(),
    noteEntity: null,
    attachments: []
  };

  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_CREATE_CLEAR
    });
  }

  public switchSetTimeAndNotification = () => {
    this.setState({
      showPickers: !this.state.showPickers
    })
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;

    this.setState({
      [identifier]: date,
      hasModifiedData: true
    });
  }

  public selectTime = (time) => {
    this.setState({
      notificationTime: time.toDate() ,
      hasModifiedData: true
    })
  }

  public selectEntityForNote = (entity): void => {
    this.setState({
      selectedEntityForNoteManuallyChanged: true,
      selectedEntityForNote: entity,
      hasModifiedData: true
    });
  }

  public clearEntityForNote = (): void => {
    this.setState({
      selectedEntityForNote: null,
      hasModifiedData: true
    });
  }

  public save = () => {
    const payload: any = {
      content: {
        note: this.state.note
      },
      eventTypeId: 17, // note
      amazonFolderName: this.state.amazonFolderName,
    }

    if (this.state.selectedEntityForNote instanceof Property) {
      payload.propertyId = this.state.selectedEntityForNote.id;
    }

    if (this.state.selectedEntityForNote instanceof Unit) {
      payload.unitId = this.state.selectedEntityForNote.id;
    }

    if (this.state.selectedEntityForNote instanceof Contract) {
      payload.contractId = this.state.selectedEntityForNote.id;
    }

    if (this.state.selectedEntityForNote instanceof Company) {
      if (this.state.selectedEntityForNote?.isOwner) {
        payload.ownerId = this.state.selectedEntityForNote.id;
      }

      payload.companyId = this.state.selectedEntityForNote.id;
    }

    if (this.state.selectedEntityForNote instanceof Person) {
      payload.contactId = this.state.selectedEntityForNote.id;
    }

    const snoozeDate = !!this.state.notificationDate && !!this.state.notificationTime ? new Date(
      this.state.notificationDate.getFullYear(),
      this.state.notificationDate.getMonth(),
      this.state.notificationDate.getDate(),
      this.state.notificationTime.getHours(),
      this.state.notificationTime.getMinutes()
    ) : null;

    payload.snoozeDate = this.state.showPickers ? snoozeDate : null;

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_EVENT_CREATE_START,
        payload: {...payload},
        onSuccess: this.redirectBack,
        onError: () => {
          this.setState({
            hasModifiedData: true,
            isSaving: false
          });
        }
      });
    })
  }

  public render() {
    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.redirectBack}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <h1>{this.trans("note")}</h1>
              <div className="button-container-small">
                <Button
                  color="primary"
                  onClick={this.redirectBack}
                  style={{marginRight: "20px"}}
                  disabled={this.state.isSaving}
                >
                  {this.trans("button-cancel")}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.save}
                  disabled={this.state.isSaving}
                >
                  {this.trans("button-create")}
                </Button>
              </div>
            </div>
          </div>

          <div className="box component-task-update">
            <div className="component-wrapper no-margin-top no-shadow">
              <div className="component">
                <Card className="card">
                  <div className="row">
                    <div className="grid"></div>
                    <div className="grid">
                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-note"
                        type="text"
                        multiline
                        rowsMax="25"
                        label={this.state.note.length > 0 ? this.trans("note") : this.trans("type-a-note")}
                        value={this.state.note}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "note")}
                        autoFocus={true}
                        variant="standard"
                        error={!!this.getErrorFor("note")}
                      />
                      {!!this.getErrorFor("note") && <div className="component-error-text">{this.getErrorFor("note")}</div>}

                      {/* <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.showPickers}
                            onChange={this.switchSetTimeAndNotification}
                            color="primary"
                          />
                        }
                        label={this.trans("label-set-time-notification")}
                      /> */}

                      {this.state.showPickers && (
                        <div>
                          <div className="note-task-container" style={{display: "flex", justifyContent: "space-between", alignItems: "flex-end"}}>
                            <div style={{width: "68%"}}>
                              <DatePickerComponent
                                {...this.props}
                                className="scroll-to-notificationDate"
                                label={this.trans("label-date")}
                                initialDate={this.state.notificationDate}
                                onChange={date => this.selectDate(date, "notificationDate")}
                                minDate={new Date()}
                                minDatePlusDays={0}
                                clearButton={true}
                                error={this.getErrorFor("notificationDate")}
                              />
                            </div>
                            <div style={{width: "32%", marginBottom: "13px", marginLeft: "15px"}}>
                              <MuiPickersUtilsProvider utils={MomentUtils}>
                                <TimePicker
                                  ampm={false}
                                  format="HH:mm"
                                  value={this.state.notificationTime}
                                  onChange={this.selectTime}
                                />
                              </MuiPickersUtilsProvider>
                            </div>
                          </div>
                          <p style={{margin: "10px 0", fontSize: "12px", color: "gray"}}>{this.trans("to-set-a-notification")}</p>
                        </div>
                      )}

                      <div className="search-bar-container">
                        <Searchbar
                          {...this.props}
                          id="selectedEntityForNewNote"
                          className="scroll-to-objectId"
                          floatingLabelText={this.trans("object")}
                          allResults={true}
                          objectField={true}
                          onChange={this.selectEntityForNote}
                          onClear={this.clearEntityForNote}
                          selectedEntity={this.state.selectedEntityForNote}
                          searchParameter={"objectForNoteSearch"}
                          error={this.getErrorFor("objectId")}
                          
                          searchText={this.state.selectedEntityForNote ? `${this.state.selectedEntityForNote.nameOfEntity}, ${this.state.selectedEntityForNote.displayName}` : null}
                        />
                      </div>
                    </div>
                  </div>
                </Card>
              </div>
            </div>

            <div className="component-wrapper no-shadow">
              <Attachment
                {...this.props}
                typeOfComponent="shared"
                title={this.trans("shared-attachments-for-note")}
                relation="eventId"
                // entity={this.state.noteEntity}
                amazonFolderName={!!this.state.amazonFolderName ? this.state.amazonFolderName : null}
                onLastImageDeleted={() => (this.refs.EntityAvatar as any) && (this.refs.EntityAvatar as any).revert()}
                updateParentState={attachments => this.setState({attachments: attachments})}
                attachments={this.state.attachments}
              />
            </div>
          </div>
        </div>

        <LeavePromptDialog
          {...this.props}
          prioritizeClosing={true}
          onClose={() => this.setState({ openLeavePrompt: false, nextPath: "" })}
          openLeavePrompt={this.state.openLeavePrompt}
          onDiscard={this.leave.bind(this)}
          onSave={() => { this.setState({ openLeavePrompt: false }); this.save(); }}
          hideCross={true}
          leavePrompt={true}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    properties: state.properties,
    units: state.units,
    events: state.events,
    component: state.eventCreate,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  NoteCreate
);